<div *ngIf="loader" id="spinerLoader" class="container">
    <div class="loader">Loading...</div>
</div>
<div class="card-body-tab">
    <div class="col-12 px-2">
        <div class="cards-body">
            <div class="needs-review-filter">
                <label class="needs-review-filter__label mb-0">
                    <input
                        type="checkbox"
                        [(ngModel)]="showAwaitingVerificationOnly"
                        (ngModelChange)="onAwaitingVerificationFilterChange()"
                    />
                    Needs verification
                </label>
            </div>
            <div class="tableSpacing">
                <div class="box-body table-responsive-sm table-responsive-md table-responsive-lg overflow-x-auto">
                    <table id="blocktime_report_table" class="table card-layout table-striped table">
                        <thead>
                            <tr id="blocktimeRecord_headingId">
                                <td class="header_td table_heading">
                                    <div class="header_container text-primary">
                                        <div
                                            class="header-color cursorPointer reportfield-width background-color-whiteSmoke box-shadow-whiteSmoke position-sticky left-minus_0_5"
                                        >
                                            Action
                                        </div>
                                        <div
                                            class="header-color cursorPointer reportfield-width background-color-whiteSmoke position-sticky left-9_5"
                                            (click)="
                                                sortBy = 'srCreatedOnDate';
                                                sortOrder = !sortOrder;
                                                blockTimeReportSorting.srCreatedOnDate = !blockTimeReportSorting.srCreatedOnDate
                                            "
                                        >
                                            Date
                                            <i *ngIf="blockTimeReportSorting.srCreatedOnDate" class="fa fa-chevron-up margin-left-7"></i>
                                            <i *ngIf="!blockTimeReportSorting.srCreatedOnDate" class="fa fa-chevron-down margin-left-7"></i>
                                        </div>
                                        <div
                                            class="header-color cursorPointer reportfield-width background-color-whiteSmoke position-sticky left-19_5"
                                            (click)="
                                                sortBy = 'tripID';
                                                sortOrder = !sortOrder;
                                                blockTimeReportSorting.tripID = !blockTimeReportSorting.tripID
                                            "
                                        >
                                            Trip #
                                            <i *ngIf="blockTimeReportSorting.tripID" class="fa fa-chevron-up margin-left-7"></i>
                                            <i *ngIf="!blockTimeReportSorting.tripID" class="fa fa-chevron-down margin-left-7"></i>
                                        </div>
                                        <div
                                            class="header-color cursorPointer reportfield-width background-color-whiteSmoke position-sticky left-29_5"
                                            (click)="
                                                sortBy = 'customerName';
                                                sortOrder = !sortOrder;
                                                blockTimeReportSorting.customerName = !blockTimeReportSorting.customerName
                                            "
                                        >
                                            Customer
                                            <i *ngIf="blockTimeReportSorting.customerName" class="fa fa-chevron-up margin-left-7"></i>
                                            <i *ngIf="!blockTimeReportSorting.customerName" class="fa fa-chevron-down margin-left-7"></i>
                                        </div>
                                        <div
                                            class="header-color cursorPointer reportfield-width"
                                            (click)="
                                                sortBy = 'serviceType';
                                                sortOrder = !sortOrder;
                                                blockTimeReportSorting.serviceType = !blockTimeReportSorting.serviceType
                                            "
                                        >
                                            SR Type
                                            <i *ngIf="blockTimeReportSorting.serviceType" class="fa fa-chevron-up margin-left-7"></i>
                                            <i *ngIf="!blockTimeReportSorting.serviceType" class="fa fa-chevron-down margin-left-7"></i>
                                        </div>
                                        <div
                                            class="header-color cursorPointer reportfield-width reportfield-width-14"
                                            (click)="
                                                sortBy = 'additionalOrgans';
                                                sortOrder = !sortOrder;
                                                blockTimeReportSorting.additionalOrgans = !blockTimeReportSorting.additionalOrgans
                                            "
                                        >
                                            Organ Type
                                            <i *ngIf="blockTimeReportSorting.additionalOrgans" class="fa fa-chevron-up margin-left-7"></i>
                                            <i
                                                *ngIf="!blockTimeReportSorting.additionalOrgans"
                                                class="fa fa-chevron-down margin-left-7"
                                            ></i>
                                        </div>
                                        <div
                                            class="header-color cursorPointer reportfield-width reportfield-width-14"
                                            (click)="
                                                sortBy = 'groundVendor';
                                                sortOrder = !sortOrder;
                                                blockTimeReportSorting.groundVendor = !blockTimeReportSorting.groundVendor
                                            "
                                        >
                                            Ground Vendor
                                            <i *ngIf="blockTimeReportSorting.groundVendor" class="fa fa-chevron-up margin-left-7"></i>
                                            <i *ngIf="!blockTimeReportSorting.groundVendor" class="fa fa-chevron-down margin-left-7"></i>
                                        </div>
                                        <div
                                            class="header-color cursorPointer reportfield-width"
                                            (click)="
                                                sortBy = 'unosid';
                                                sortOrder = !sortOrder;
                                                blockTimeReportSorting.unosid = !blockTimeReportSorting.unosid
                                            "
                                        >
                                            Unos ID
                                            <i *ngIf="blockTimeReportSorting.unosid" class="fa fa-chevron-up margin-left-7"></i>
                                            <i *ngIf="!blockTimeReportSorting.unosid" class="fa fa-chevron-down margin-left-7"></i>
                                        </div>
                                        <div
                                            class="header-color cursorPointer reportfield-width"
                                            (click)="
                                                sortBy = 'airVendor';
                                                sortOrder = !sortOrder;
                                                blockTimeReportSorting.airVendor = !blockTimeReportSorting.airVendor
                                            "
                                        >
                                            Air Vendor
                                            <i *ngIf="blockTimeReportSorting.airVendor" class="fa fa-chevron-up margin-left-7"></i>
                                            <i *ngIf="!blockTimeReportSorting.airVendor" class="fa fa-chevron-down margin-left-7"></i>
                                        </div>
                                        <div
                                            class="header-color cursorPointer reportfield-width"
                                            (click)="
                                                sortBy = 'outboundReposition';
                                                sortOrder = !sortOrder;
                                                blockTimeReportSorting.outboundReposition = !blockTimeReportSorting.outboundReposition
                                            "
                                        >
                                            OB Repo
                                            <i *ngIf="blockTimeReportSorting.outboundReposition" class="fa fa-chevron-up margin-left-7"></i>
                                            <i
                                                *ngIf="!blockTimeReportSorting.outboundReposition"
                                                class="fa fa-chevron-down margin-left-7"
                                            ></i>
                                        </div>
                                        <div
                                            class="header-color cursorPointer reportfield-width"
                                            (click)="
                                                sortBy = 'obEstimatedBlockHours';
                                                sortOrder = !sortOrder;
                                                blockTimeReportSorting.obEstimatedBlockHours = !blockTimeReportSorting.obEstimatedBlockHours
                                            "
                                        >
                                            OB Repo Hours
                                            <i
                                                *ngIf="blockTimeReportSorting.obEstimatedBlockHours"
                                                class="fa fa-chevron-up margin-left-7"
                                            ></i>
                                            <i
                                                *ngIf="!blockTimeReportSorting.obEstimatedBlockHours"
                                                class="fa fa-chevron-down margin-left-7"
                                            ></i>
                                        </div>
                                        <div
                                            class="header-color cursorPointer reportfield-width"
                                            (click)="
                                                sortBy = 'routing';
                                                sortOrder = !sortOrder;
                                                blockTimeReportSorting.routing = !blockTimeReportSorting.routing
                                            "
                                        >
                                            Routing
                                            <i *ngIf="blockTimeReportSorting.routing" class="fa fa-chevron-up margin-left-7"></i>
                                            <i *ngIf="!blockTimeReportSorting.routing" class="fa fa-chevron-down margin-left-7"></i>
                                        </div>
                                        <div
                                            class="header-color cursorPointer reportfield-width"
                                            (click)="
                                                sortBy = 'liveFlightHours';
                                                sortOrder = !sortOrder;
                                                blockTimeReportSorting.routing = !blockTimeReportSorting.liveFlightHours
                                            "
                                        >
                                            Live Flight Hours
                                            <i *ngIf="blockTimeReportSorting.liveFlightHours" class="fa fa-chevron-up margin-left-7"></i>
                                            <i *ngIf="!blockTimeReportSorting.liveFlightHours" class="fa fa-chevron-down margin-left-7"></i>
                                        </div>
                                        <div
                                            class="header-color cursorPointer reportfield-width"
                                            (click)="
                                                sortBy = 'inboundReposition';
                                                sortOrder = !sortOrder;
                                                blockTimeReportSorting.inboundReposition = !blockTimeReportSorting.inboundReposition
                                            "
                                        >
                                            IB Repo
                                            <i *ngIf="blockTimeReportSorting.inboundReposition" class="fa fa-chevron-up margin-left-7"></i>
                                            <i
                                                *ngIf="!blockTimeReportSorting.inboundReposition"
                                                class="fa fa-chevron-down margin-left-7"
                                            ></i>
                                        </div>
                                        <div
                                            class="header-color cursorPointer reportfield-width"
                                            (click)="
                                                sortBy = 'ibEstimatedBlockHours';
                                                sortOrder = !sortOrder;
                                                blockTimeReportSorting.ibEstimatedBlockHours = !blockTimeReportSorting.ibEstimatedBlockHours
                                            "
                                        >
                                            IB Repo Hours
                                            <i
                                                *ngIf="blockTimeReportSorting.ibEstimatedBlockHours"
                                                class="fa fa-chevron-up margin-left-7"
                                            ></i>
                                            <i
                                                *ngIf="!blockTimeReportSorting.ibEstimatedBlockHours"
                                                class="fa fa-chevron-down margin-left-7"
                                            ></i>
                                        </div>
                                        <div
                                            class="header-color cursorPointer reportfield-width reportfield-width-14"
                                            (click)="
                                                sortBy = 'tailNumber';
                                                sortOrder = !sortOrder;
                                                blockTimeReportSorting.tailNumber = !blockTimeReportSorting.tailNumber
                                            "
                                        >
                                            Tail Number
                                            <i *ngIf="blockTimeReportSorting.tailNumber" class="fa fa-chevron-up margin-left-7"></i>
                                            <i *ngIf="!blockTimeReportSorting.tailNumber" class="fa fa-chevron-down margin-left-7"></i>
                                        </div>
                                        <div
                                            class="header-color cursorPointer reportfield-width reportfield-width-14"
                                            (click)="
                                                sortBy = 'aircraftType';
                                                sortOrder = !sortOrder;
                                                blockTimeReportSorting.aircraftType = !blockTimeReportSorting.aircraftType
                                            "
                                        >
                                            Aircraft Types
                                            <i *ngIf="blockTimeReportSorting.aircraftType" class="fa fa-chevron-up margin-left-7"></i>
                                            <i *ngIf="!blockTimeReportSorting.aircraftType" class="fa fa-chevron-down margin-left-7"></i>
                                        </div>
                                        <div
                                            class="header-color cursorPointer reportfield-width reportfield-width-14"
                                            (click)="
                                                sortBy = 'estimatedBlockHours';
                                                sortOrder = !sortOrder;
                                                blockTimeReportSorting.estimatedBlockHours = !blockTimeReportSorting.estimatedBlockHours
                                            "
                                        >
                                            Est. Block Hours
                                            <i
                                                *ngIf="blockTimeReportSorting.estimatedBlockHours"
                                                class="fa fa-chevron-up margin-left-7"
                                            ></i>
                                            <i
                                                *ngIf="!blockTimeReportSorting.estimatedBlockHours"
                                                class="fa fa-chevron-down margin-left-7"
                                            ></i>
                                        </div>
                                        <div
                                            class="header-color cursorPointer reportfield-width reportfield-width-17"
                                            (click)="
                                                sortBy = 'blockHours';
                                                sortOrder = !sortOrder;
                                                blockTimeReportSorting.actualBlockTime = !blockTimeReportSorting.actualBlockTime
                                            "
                                        >
                                            Actual Block Time
                                            <i *ngIf="blockTimeReportSorting.actualBlockTime" class="fa fa-chevron-up margin-left-7"></i>
                                            <i *ngIf="!blockTimeReportSorting.actualBlockTime" class="fa fa-chevron-down margin-left-7"></i>
                                        </div>
                                        <div
                                            class="header-color cursorPointer reportfield-width reportfield-width-17"
                                            (click)="
                                                sortBy = 'cancellationHours';
                                                sortOrder = !sortOrder;
                                                blockTimeReportSorting.cancellationHours = !blockTimeReportSorting.cancellationHours
                                            "
                                        >
                                            Cancellation Hours
                                            <i *ngIf="blockTimeReportSorting.cancellationHours" class="fa fa-chevron-up margin-left-7"></i>
                                            <i
                                                *ngIf="!blockTimeReportSorting.cancellationHours"
                                                class="fa fa-chevron-down margin-left-7"
                                            ></i>
                                        </div>
                                        <div
                                            class="header-color cursorPointer reportfield-width reportfield-width-14"
                                            (click)="
                                                sortBy = 'aircraftSize';
                                                sortOrder = !sortOrder;
                                                blockTimeReportSorting.aircraftSize = !blockTimeReportSorting.aircraftSize
                                            "
                                        >
                                            Aircraft Size
                                            <i *ngIf="blockTimeReportSorting.aircraftSize" class="fa fa-chevron-up margin-left-7"></i>
                                            <i *ngIf="!blockTimeReportSorting.aircraftSize" class="fa fa-chevron-down margin-left-7"></i>
                                        </div>
                                        <div
                                            class="header-color cursorPointer reportfield-width"
                                            (click)="
                                                sortBy = 'cost';
                                                sortOrder = !sortOrder;
                                                blockTimeReportSorting.cost = !blockTimeReportSorting.cost
                                            "
                                        >
                                            Cost
                                            <i *ngIf="blockTimeReportSorting.cost" class="fa fa-chevron-up margin-left-7"></i>
                                            <i *ngIf="!blockTimeReportSorting.cost" class="fa fa-chevron-down margin-left-7"></i>
                                        </div>
                                        <div
                                            class="header-color cursorPointer reportfield-width"
                                            (click)="
                                                sortBy = 'profit';
                                                sortOrder = !sortOrder;
                                                blockTimeReportSorting.profit = !blockTimeReportSorting.profit
                                            "
                                        >
                                            Profit
                                            <i *ngIf="blockTimeReportSorting.profit" class="fa fa-chevron-up margin-left-7"></i>
                                            <i *ngIf="!blockTimeReportSorting.profit" class="fa fa-chevron-down margin-left-7"></i>
                                        </div>
                                        <div
                                            class="header-color cursorPointer reportfield-width"
                                            (click)="
                                                sortBy = 'rate';
                                                sortOrder = !sortOrder;
                                                blockTimeReportSorting.rate = !blockTimeReportSorting.rate
                                            "
                                        >
                                            Rate
                                            <i *ngIf="blockTimeReportSorting.rate" class="fa fa-chevron-up margin-left-7"></i>
                                            <i *ngIf="!blockTimeReportSorting.rate" class="fa fa-chevron-down margin-left-7"></i>
                                        </div>
                                        <div
                                            class="header-color cursorPointer reportfield-width reportfield-width-14"
                                            (click)="
                                                sortBy = 'flightMargin';
                                                sortOrder = !sortOrder;
                                                blockTimeReportSorting.flightMargin = !blockTimeReportSorting.flightMargin
                                            "
                                        >
                                            Flight Margin
                                            <i *ngIf="blockTimeReportSorting.flightMargin" class="fa fa-chevron-up margin-left-7"></i>
                                            <i *ngIf="!blockTimeReportSorting.flightMargin" class="fa fa-chevron-down margin-left-7"></i>
                                        </div>
                                        <div
                                            class="header-color cursorPointer reportfield-width"
                                            (click)="
                                                sortBy = 'invoiceID';
                                                sortOrder = !sortOrder;
                                                blockTimeReportSorting.invoiceID = !blockTimeReportSorting.invoiceID
                                            "
                                        >
                                            Invoice #
                                            <i *ngIf="blockTimeReportSorting.invoiceID" class="fa fa-chevron-up margin-left-7"></i>
                                            <i *ngIf="!blockTimeReportSorting.invoiceID" class="fa fa-chevron-down margin-left-7"></i>
                                        </div>
                                        <div
                                            class="header-color cursorPointer reportfield-width d-flex justify-content-center"
                                            (click)="
                                                sortBy = 'ar';
                                                sortOrder = !sortOrder;
                                                blockTimeReportSorting.ar = !blockTimeReportSorting.ar
                                            "
                                        >
                                            <span>A/R</span>
                                            <i *ngIf="blockTimeReportSorting.ar" class="fa fa-chevron-up margin-left-7"></i>
                                            <i *ngIf="!blockTimeReportSorting.ar" class="fa fa-chevron-down margin-left-7"></i>
                                        </div>
                                        <div
                                            class="header-color cursorPointer reportfield-width d-flex justify-content-center"
                                            (click)="
                                                sortBy = 'ap';
                                                sortOrder = !sortOrder;
                                                blockTimeReportSorting.ap = !blockTimeReportSorting.ap
                                            "
                                        >
                                            <span>A/P</span>
                                            <i *ngIf="blockTimeReportSorting.ap" class="fa fa-chevron-up margin-left-7"></i>
                                            <i *ngIf="!blockTimeReportSorting.ap" class="fa fa-chevron-down margin-left-7"></i>
                                        </div>
                                        <div class="header-color cursorPointer reportfield-width">
                                            <span>Note</span>
                                        </div>
                                    </div>
                                </td>
                            </tr>
                        </thead>
                        <tbody>
                            <tr
                                *ngFor="
                                    let record of blockTimeReportData
                                        | filterIbRepoAwaitingVerification: showAwaitingVerificationOnly
                                        | orderBy: sortBy : sortOrder
                                        | filter: searchText
                                        | paginate: { itemsPerPage: selectedPage, currentPage: currentPageNumber };
                                    let record_index = index
                                "
                            >
                                <td>
                                    <div id="blocktimeRecord_main_row_id" class="row_container">
                                        <div
                                            class="title_container reportfield-width position-sticky left-minus_0_5"
                                            [ngClass]="
                                                record_index % 2 == 0
                                                    ? 'background-color-white box-shadow-white'
                                                    : 'background-color-whiteSmoke box-shadow-whiteSmoke'
                                            "
                                        >
                                            <div class="row_title">Action</div>
                                            <div class="row_detail">
                                                <button
                                                    id="editBlockTimeReportButton"
                                                    class="mr-2 flat-butt flat-info-butt flat-info-grad-butt add-note-button"
                                                    data-target="#addBlockTimeReportRecord"
                                                    data-toggle="modal"
                                                    title="Edit blocktime record"
                                                    [disabled]="isInternalReadOnly"
                                                    [ngClass]="isInternalReadOnly ? 'notAllowedPointer' : ''"
                                                    (click)="openEditBlockTimeReport(record)"
                                                >
                                                    <i class="fa fa-pencil"></i>
                                                </button>
                                                <button
                                                    id="deleteBlockTimeReportButton"
                                                    class="flat-butt flat-info-butt flat-info-grad-butt add-note-button"
                                                    title="Delete blocktime record"
                                                    [disabled]="!record.blockTimeReportID || isInternalReadOnly"
                                                    [ngClass]="isInternalReadOnly || !record.blockTimeReportID ? 'notAllowedPointer' : ''"
                                                    (click)="deleteBlockTimeRecord(record.blockTimeReportID)"
                                                >
                                                    <i class="fa fa-minus-circle"></i>
                                                </button>
                                                <button
                                                    *ngIf="!record.isRecordSplitted && record.parentBlockTimeReportID == null"
                                                    id="splitBlockTimeReportButton"
                                                    class="flat-butt flat-info-butt flat-info-grad-butt add-note-button"
                                                    title="Split the record"
                                                    [disabled]="isInternalReadOnly"
                                                    [ngClass]="isInternalReadOnly ? 'notAllowedPointer' : ''"
                                                    (click)="openSplitBlockTimeRecordPopup(record)"
                                                >
                                                    <i class="fa fa-scissors"></i>
                                                </button>
                                            </div>
                                        </div>
                                        <div
                                            class="title_container reportfield-width position-sticky left-9_5"
                                            [ngClass]="record_index % 2 == 0 ? 'background-color-white' : 'background-color-whiteSmoke'"
                                        >
                                            <div class="row_title">Date</div>
                                            <div class="row_detail">
                                                {{ record?.srCreatedOnDate | date: timeZone }}
                                            </div>
                                        </div>
                                        <div
                                            class="title_container reportfield-width position-sticky left-19_5"
                                            [ngClass]="record_index % 2 == 0 ? 'background-color-white' : 'background-color-whiteSmoke'"
                                        >
                                            <div class="row_title">Trip #</div>
                                            <div class="row_detail cursorPointer">
                                                <a href="{{ itineraryPageRedirectUrl }}/{{ record.serviceRequestID }}/Report">
                                                    {{ record.tripID }}
                                                </a>
                                            </div>
                                        </div>
                                        <div
                                            class="title_container reportfield-width position-sticky left-29_5"
                                            [ngClass]="record_index % 2 == 0 ? 'background-color-white' : 'background-color-whiteSmoke'"
                                        >
                                            <div class="row_title">Customer</div>
                                            <div class="row_detail">
                                                {{ record?.customer?.customerName }}
                                            </div>
                                        </div>
                                        <div class="title_container reportfield-width">
                                            <div class="row_title">SR Type</div>
                                            <div class="row_detail">
                                                {{ record.serviceType }}
                                            </div>
                                        </div>
                                        <div class="title_container reportfield-width reportfield-width-14">
                                            <div class="row_title">Organ Type</div>
                                            <div class="row_detail" style="max-height: 5rem; overflow-y: auto">
                                                {{ record.additionalOrgans }}
                                            </div>
                                        </div>
                                        <div class="title_container reportfield-width reportfield-width-14">
                                            <div class="row_title">Ground Vendor</div>
                                            <div class="row_detail">
                                                {{ record.groundVendor }}
                                            </div>
                                        </div>
                                        <div class="title_container reportfield-width">
                                            <div class="row_title">Unos ID</div>
                                            <div class="row_detail">
                                                {{ record.unosid }}
                                            </div>
                                        </div>
                                        <div class="title_container reportfield-width">
                                            <div class="row_title">Air Vendor</div>
                                            <div class="row_detail">
                                                {{ record.airVendor }}
                                            </div>
                                        </div>
                                        <div class="title_container reportfield-width">
                                            <div class="row_title">OB Repo</div>
                                            <div class="row_detail">
                                                {{ record.outboundReposition }}
                                            </div>
                                        </div>
                                        <div class="title_container reportfield-width">
                                            <div class="row_title">OB Repo Hours</div>
                                            <div class="row_detail">
                                                {{ record.obEstimatedBlockHours | number: '1.2-2' }}
                                            </div>
                                        </div>
                                        <div class="title_container reportfield-width">
                                            <div class="row_title">Routing</div>
                                            <div class="row_detail">
                                                {{ record.routing }}
                                            </div>
                                        </div>
                                        <div class="title_container reportfield-width">
                                            <div class="row_title">Live Flight Hours</div>
                                            <div class="row_detail">
                                                {{ record.liveFlightHours }}
                                            </div>
                                        </div>
                                        <div class="title_container reportfield-width">
                                            <div class="row_title">IB Repo</div>
                                            <div class="row_detail">
                                                <ng-container *ngIf="record.actualInBoundReposition">
                                                    <span class="ib-repo-planned">{{ record.inboundReposition }}</span>
                                                    → {{ record.actualInBoundReposition }}
                                                </ng-container>
                                                <ng-container *ngIf="!record.actualInBoundReposition">
                                                    {{ record.inboundReposition }}
                                                </ng-container>
                                            </div>
                                        </div>
                                        <div class="title_container reportfield-width">
                                            <div class="row_title">IB Repo Hours</div>
                                            <div class="row_detail">
                                                {{ record.ibEstimatedBlockHours | number: '1.2-2' }}
                                                <app-ds-badge
                                                    *ngIf="record.ibRepoAwaitingVerification"
                                                    class="needs-review-badge"
                                                    label="Needs verification"
                                                    size="sm"
                                                    theme="warning"
                                                    [matTooltip]="record | ibRepoVerificationTooltip"
                                                ></app-ds-badge>
                                            </div>
                                        </div>
                                        <div class="title_container reportfield-width reportfield-width-14">
                                            <div class="row_title">Tail Number</div>
                                            <div class="row_detail">
                                                <a href="https://flightaware.com/live/flight/{{ record.tailNumber }}" target="blank">
                                                    {{ record.tailNumber }}
                                                </a>
                                            </div>
                                        </div>
                                        <div class="title_container reportfield-width reportfield-width-14">
                                            <div class="row_title">Aircraft Types</div>
                                            <div class="row_detail">
                                                {{ record.aircraftType }}
                                            </div>
                                        </div>
                                        <div class="title_container reportfield-width reportfield-width-14">
                                            <div class="row_title">Est. Block Hours</div>
                                            <div class="row_detail">
                                                {{ record.estimatedBlockHours }}
                                            </div>
                                        </div>
                                        <div class="title_container reportfield-width reportfield-width-17">
                                            <div class="row_title">Actual Block Time</div>
                                            <div class="row_detail">
                                                {{ record.actualBlockTime }}
                                            </div>
                                        </div>
                                        <div class="title_container reportfield-width reportfield-width-17">
                                            <div class="row_title">Cancellation Hours</div>
                                            <div class="row_detail">
                                                {{ record.cancellationHours | number: '1.2-2' }}
                                            </div>
                                        </div>
                                        <div class="title_container reportfield-width reportfield-width-14">
                                            <div class="row_title">Aircraft Size</div>
                                            <div class="row_detail">
                                                {{ record.aircraftSize }}
                                            </div>
                                        </div>
                                        <div class="title_container reportfield-width">
                                            <div class="row_title">Cost</div>
                                            <div class="row_detail">
                                                <ng-container *ngIf="record.cost"> {{ record.cost }} $ </ng-container>
                                            </div>
                                        </div>
                                        <div class="title_container reportfield-width">
                                            <div class="row_title">Profit</div>
                                            <div class="row_detail">
                                                <ng-container *ngIf="record.profit"> {{ record.profit }} $ </ng-container>
                                            </div>
                                        </div>
                                        <div class="title_container reportfield-width">
                                            <div class="row_title">Rate</div>
                                            <div class="row_detail">
                                                <ng-container *ngIf="record.rate"> {{ record.rate }} % </ng-container>
                                            </div>
                                        </div>
                                        <div class="title_container reportfield-width reportfield-width-14">
                                            <div class="row_title">Flight Margin</div>
                                            <div class="row_detail">
                                                <ng-container *ngIf="record.flightMargin"> {{ record.flightMargin }} % </ng-container>
                                            </div>
                                        </div>
                                        <div class="title_container reportfield-width">
                                            <div class="row_title">Invoice #</div>
                                            <div class="row_detail">
                                                {{ record.invoiceID }}
                                            </div>
                                        </div>
                                        <div class="title_container reportfield-width">
                                            <div class="row_title">A/R</div>
                                            <div class="row_detail d-flex justify-content-center">
                                                <input
                                                    class="block_time_report_checkbox"
                                                    type="checkbox"
                                                    [disabled]="isInternalReadOnly"
                                                    [(ngModel)]="record.ar"
                                                    (change)="updateArOrAp(record, 'A/R')"
                                                />
                                            </div>
                                        </div>
                                        <div class="title_container reportfield-width">
                                            <div class="row_title">A/P</div>
                                            <div class="row_detail d-flex justify-content-center">
                                                <input
                                                    class="block_time_report_checkbox"
                                                    type="checkbox"
                                                    [disabled]="isInternalReadOnly"
                                                    [(ngModel)]="record.ap"
                                                    (change)="updateArOrAp(record, 'A/P')"
                                                />
                                            </div>
                                        </div>
                                        <div class="title_container reportfield-width">
                                            <div class="row_title">Note</div>
                                            <div class="row_detail">
                                                <input
                                                    id="note-{{ record_index }}"
                                                    class="form-control cursorPointer"
                                                    data-placement="auto left"
                                                    data-toggle="popover"
                                                    readonly
                                                    type="textarea"
                                                    [attr.data-content]="record.note"
                                                    [(ngModel)]="record.note"
                                                    (click)="togglePopOver()"
                                                />
                                            </div>
                                        </div>
                                    </div>
                                </td>
                            </tr>
                        </tbody>
                    </table>
                </div>
                <div *ngIf="blockTimeReportData.length == 0" class="mt-2" style="color: #a82b41">
                    <b>No Records Found</b>
                </div>
                <div *ngIf="blockTimeReportData.length > 0" class="col-md-12 p-3">
                    <div class="col-md-6 p-0">
                        {{ pagination }}
                    </div>
                    <div class="col-md-6 pagination text-end mt-1">
                        <pagination-controls
                            [maxSize]="6"
                            [nextLabel]="''"
                            [previousLabel]="''"
                            [responsive]="responsive"
                            (pageChange)="currentPageNumber = $event; onPageChange()"
                        >
                        </pagination-controls>
                    </div>
                </div>
            </div>
        </div>
    </div>
</div>

<app-block-time-report-grid [data]="totalOfBlockTimeReportValues"></app-block-time-report-grid>

<!-- todo: refactoring. move it to the separate component -->
<div *ngIf="isOpenAddEditBlockTimeRecordPopUp" id="addBlockTimeReportRecord" class="modal" data-backdrop="static" data-keyboard="false">
    <div class="modal-dialog modal-lg">
        <div class="modal-content">
            <div class="modal-header">
                <button class="close close-btn" aria-label="Close" data-dismiss="modal" type="button" (click)="closeBlockTimeReportModel()">
                    <i class="fa fa-close"></i>
                </button>
                <h4 class="modal-title">{{ isEditBlockTimeRecord ? 'Edit' : 'Add New' }} Record</h4>
            </div>
            <form #blockTimeReportForm="ngForm" name="addEditBlockTimeReportForm">
                <div class="modal-body">
                    <div class="member-card">
                        <div class="dialog-row">
                            <div class="dialog-cell">
                                <div class="form-group">
                                    <label>
                                        <span>Trip #</span><span class="text-danger"> * </span>
                                        <span *ngIf="blockTimeReportForm.submitted && tripID.invalid">
                                            <span *ngIf="tripID.hasError('required')" class="text-danger">required</span>
                                        </span>
                                    </label>
                                    <ngx-select-dropdown
                                        id="tripID"
                                        #ngxSelectDropDownCustomer
                                        #tripID="ngModel"
                                        [class.dropdown-readonly]="isEditBlockTimeRecord"
                                        name="tripID"
                                        required
                                        tabindex="0"
                                        [config]="tripDropdownConfig"
                                        [disabled]="isEditBlockTimeRecord"
                                        [multiple]="false"
                                        [ngClass]="blockTimeReportForm.submitted && customer.invalid ? 'is-invalid-dropdown' : ''"
                                        [options]="trips"
                                        [(ngModel)]="blockTimeReportRecord.tripID"
                                        (change)="onTripChange($event.value)"
                                        (click)="focusNgxSelectDropDownSearch(ngxSelectDropDownCustomer)"
                                    ></ngx-select-dropdown>
                                </div>
                            </div>
                            <div class="dialog-cell">
                                <div class="form-group">
                                    <label>
                                        <span>Customer </span><span class="text-danger">*</span>
                                        <span *ngIf="blockTimeReportForm.submitted && customer.invalid">
                                            <span *ngIf="customer.errors.required" class="text-danger">required</span>
                                        </span>
                                    </label>
                                    <ngx-select-dropdown
                                        id="customer"
                                        #customer="ngModel"
                                        #ngxSelectDropDownCustomer
                                        [class.dropdown-readonly]="isEditBlockTimeRecord"
                                        name="customer"
                                        required
                                        tabindex="0"
                                        [config]="customerListDropdownSetting"
                                        [disabled]="isEditBlockTimeRecord"
                                        [multiple]="false"
                                        [ngClass]="blockTimeReportForm.submitted && customer.invalid ? 'is-invalid-dropdown' : ''"
                                        [options]="customerList"
                                        [(ngModel)]="blockTimeReportRecord.customer"
                                        (click)="focusNgxSelectDropDownSearch(ngxSelectDropDownCustomer)"
                                    ></ngx-select-dropdown>
                                </div>
                            </div>
                            <div class="dialog-cell">
                                <div class="form-group">
                                    <label>
                                        <span>Date </span>
                                        <span class="text-danger">*</span>
                                        <span *ngIf="blockTimeReportForm.submitted && srCreatedOnDate.invalid">
                                            <span *ngIf="srCreatedOnDate.errors.required" class="text-danger">required</span>
                                        </span>
                                    </label>
                                    <input
                                        id="srCreatedOnDate"
                                        class="form-control"
                                        #srCreatedOnDate="ngModel"
                                        name="srCreatedOnDate"
                                        onfocus="this.showPicker()"
                                        placeholder="srCreatedOnDate"
                                        readonly
                                        required
                                        type="date"
                                        [disabled]="isEditBlockTimeRecord"
                                        [max]="maxDate"
                                        [ngClass]="blockTimeReportForm.submitted && srCreatedOnDate.invalid ? 'is-invalid' : ''"
                                        [ngModel]="blockTimeReportRecord.srCreatedOnDate | date: 'yyyy-MM-dd'"
                                    />
                                </div>
                            </div>
                            <div class="dialog-cell">
                                <div class="form-group">
                                    <label>
                                        <span>SR Type </span>
                                        <span *ngIf="blockTimeReportForm.touched && serviceType.invalid">
                                            <span *ngIf="serviceType.errors.pattern" class="text-danger">Alphabets only</span>
                                        </span>
                                    </label>
                                    <input
                                        id="serviceType"
                                        class="form-control readonly-field"
                                        #serviceType="ngModel"
                                        name="serviceType"
                                        readonly
                                        tabindex="-1"
                                        type="text"
                                        [(ngModel)]="blockTimeReportRecord.serviceType"
                                    />
                                </div>
                            </div>
                            <div class="dialog-cell">
                                <div class="form-group">
                                    <label>
                                        <span>Organ Type</span>
                                        <span *ngIf="blockTimeReportForm.touched && additionalOrgans.invalid">
                                            <span *ngIf="additionalOrgans.errors.pattern">Alphabets only</span>
                                        </span>
                                    </label>
                                    <input
                                        id="additionalOrgans"
                                        class="form-control readonly-field"
                                        #additionalOrgans="ngModel"
                                        name="additionalOrgans"
                                        placeholder="Select Trip #"
                                        readonly
                                        tabindex="-1"
                                        [ngClass]="blockTimeReportForm.touched && additionalOrgans.invalid ? 'is-invalid' : ''"
                                        [(ngModel)]="blockTimeReportRecord.additionalOrgans"
                                    />
                                </div>
                            </div>
                            <div class="dialog-cell">
                                <div class="form-group">
                                    <label>Unos ID</label>
                                    <input
                                        id="unosid"
                                        class="form-control readonly-field"
                                        #unosid="ngModel"
                                        name="unosid"
                                        placeholder="Unos ID"
                                        readonly
                                        tabindex="-1"
                                        type="text"
                                        [(ngModel)]="blockTimeReportRecord.unosid"
                                    />
                                </div>
                            </div>
                            <div class="dialog-cell">
                                <div class="form-group">
                                    <label>Ground Vendor</label>
                                    <input
                                        id="groundVendor"
                                        class="form-control readonly-field"
                                        #groundVendor="ngModel"
                                        name="groundVendor"
                                        placeholder="Select Trip #"
                                        readonly
                                        tabindex="-1"
                                        [(ngModel)]="blockTimeReportRecord.groundVendor"
                                    />
                                </div>
                            </div>
                            <div class="dialog-cell">
                                <div class="form-group">
                                    <label>Air Vendor</label>
                                    <span class="text-danger"> * </span>
                                    <ngx-select-dropdown
                                        id="airVendor"
                                        #airVendor="ngModel"
                                        [class.dropdown-readonly]="isEditBlockTimeRecord"
                                        name="airVendor"
                                        required
                                        tabindex="0"
                                        [config]="airVendorConfig"
                                        [disabled]="isEditBlockTimeRecord"
                                        [multiple]="false"
                                        [ngClass]="blockTimeReportForm.submitted && airVendor.invalid ? 'is-invalid-dropdown' : ''"
                                        [options]="airVendorList"
                                        [(ngModel)]="airVendorValue"
                                        (change)="onSelectAirVendor($event.value)"
                                        (click)="focusNgxSelectDropDownSearch(ngxSelectDropDownCustomer)"
                                    ></ngx-select-dropdown>
                                </div>
                            </div>
                            <div class="dialog-cell">
                                <div class="form-group position-relative">
                                    <label>
                                        <span>Tail Number </span>
                                        <span class="text-danger"> *</span>
                                        <span *ngIf="blockTimeReportForm.submitted && tailNumber.invalid">
                                            <span *ngIf="tailNumber.errors.required" class="text-danger">required</span>
                                        </span>
                                    </label>
                                    <span class="position-absolute top-left-position">N</span>
                                    <ngx-select-dropdown
                                        id="tailNumber"
                                        #ngxSelectDropDownCustomer
                                        #tailNumber="ngModel"
                                        [class.dropdown-readonly]="isEditBlockTimeRecord"
                                        name="tailNumber"
                                        required
                                        tabindex="0"
                                        [config]="tailNumberDropdownConfig"
                                        [disabled]="isEditBlockTimeRecord"
                                        [multiple]="false"
                                        [ngClass]="blockTimeReportForm.submitted && customer.invalid ? 'is-invalid-dropdown' : ''"
                                        [options]="aircrafts"
                                        [(ngModel)]="tailNumberValue"
                                        (change)="onTailNumberChange($event.value)"
                                        (click)="focusNgxSelectDropDownSearch(ngxSelectDropDownCustomer)"
                                    ></ngx-select-dropdown>
                                </div>
                            </div>
                            <div class="dialog-cell">
                                <div class="form-group">
                                    <label>Aircraft Types</label>
                                    <input
                                        id="aircraftType"
                                        class="form-control readonly-field"
                                        #aircraftType="ngModel"
                                        name="aircraftType"
                                        readonly
                                        tabindex="-1"
                                        type="text"
                                        [value]="blockTimeReportRecord.aircraftType?.name"
                                        [(ngModel)]="blockTimeReportRecord.aircraftType"
                                    />
                                </div>
                            </div>
                            <div class="dialog-cell">
                                <div class="form-group">
                                    <label>Aircraft Size</label>
                                    <input
                                        id="aircraftSize"
                                        class="form-control readonly-field"
                                        #aircraftSize="ngModel"
                                        name="aircraftSize"
                                        readonly
                                        tabindex="-1"
                                        type="text"
                                        [value]="blockTimeReportRecord.aircraftSize?.name"
                                        [(ngModel)]="blockTimeReportRecord.aircraftSize"
                                    />
                                </div>
                            </div>
                            <div class="dialog-cell">
                                <div class="form-group">
                                    <label>OB Repo</label>
                                    <ngx-select-dropdown
                                        id="outboundRepo"
                                        #ngxSelectDropDownOBRepoType
                                        #outboundRepo="ngModel"
                                        name="outboundReposition"
                                        tabindex="3"
                                        [config]="returnConfiguration('OBRepo')"
                                        [multiple]="false"
                                        [options]="airportCodes"
                                        [disabled]="isEditBlockTimeRecord"
                                        [(ngModel)]="blockTimeReportRecord.outboundReposition"
                                        (change)="blockTimeReportRecord.outboundReposition = $event.value"
                                        (click)="focusNgxSelectDropDownSearch(ngxSelectDropDownOBRepoType)"
                                    >
                                    </ngx-select-dropdown>
                                    <button
                                        *ngIf="!isEditBlockTimeRecord"
                                        class="clear-btn plus-icon mt-0"
                                        title="Clear OB Repo"
                                        type="button"
                                        (click)="blockTimeReportRecord.outboundReposition = null"
                                    >
                                        <i class="fa fa-times-circle"></i>
                                    </button>
                                </div>
                            </div>
                            <div class="dialog-cell">
                                <div class="form-group">
                                    <label>OB Repo Hours</label>
                                    <input
                                        id="obEstimatedBlockHours"
                                        class="form-control"
                                        #obEstimatedBlockHours="ngModel"
                                        min="0"
                                        name="obEstimatedBlockHours"
                                        placeholder="OB Repo Hours"
                                        type="number"
                                        [disabled]="isEditBlockTimeRecord"
                                        [(ngModel)]="blockTimeReportRecord.obEstimatedBlockHours"
                                        (change)="calculateActualBlockTime()"
                                    />
                                </div>
                            </div>
                            <div class="dialog-cell">
                                <div class="form-group">
                                    <label>Routing</label>
                                    <input
                                        id="routing"
                                        class="form-control"
                                        #routing="ngModel"
                                        name="routing"
                                        placeholder="Routing"
                                        type="text"
                                        [disabled]="isEditBlockTimeRecord"
                                        [(ngModel)]="blockTimeReportRecord.routing"
                                    />
                                </div>
                            </div>
                            <div class="dialog-cell">
                                <div class="form-group">
                                    <label>Live Flight Hours</label>
                                    <input
                                        id="liveFlightHours"
                                        class="form-control"
                                        #liveFlightHours="ngModel"
                                        min="0"
                                        name="liveFlightHours"
                                        placeholder="Live Flight Hours"
                                        type="number"
                                        [disabled]="isEditBlockTimeRecord"
                                        [(ngModel)]="blockTimeReportRecord.liveFlightHours"
                                        (change)="calculateActualBlockTime()"
                                    />
                                </div>
                            </div>
                            <div class="dialog-cell">
                                <div class="form-group">
                                    <label>IB Repo</label>
                                    <ngx-select-dropdown
                                        id="inboundReposition"
                                        #inboundReposition="ngModel"
                                        #ngxSelectDropDownIBRepoType
                                        name="inboundReposition"
                                        tabindex="4"
                                        [config]="returnConfiguration('IBRepo')"
                                        [multiple]="false"
                                        [options]="airportCodes"
                                        [disabled]="isEditBlockTimeRecord"
                                        [(ngModel)]="blockTimeReportRecord.inboundReposition"
                                        (click)="focusNgxSelectDropDownSearch(ngxSelectDropDownIBRepoType)"
                                    >
                                    </ngx-select-dropdown>
                                    <button
                                        *ngIf="!isEditBlockTimeRecord"
                                        class="clear-btn plus-icon mt-0"
                                        title="Clear IB Repo"
                                        type="button"
                                        (click)="blockTimeReportRecord.inboundReposition = null"
                                    >
                                        <i class="fa fa-times-circle"></i>
                                    </button>
                                    <small *ngIf="blockTimeReportRecord.actualInBoundReposition" class="text-muted d-block mt-1">
                                        Actual:
                                        <span class="ib-repo-planned">{{ blockTimeReportRecord.inboundReposition }}</span>
                                        → {{ blockTimeReportRecord.actualInBoundReposition }}
                                    </small>
                                </div>
                            </div>
                            <div class="dialog-cell">
                                <div class="form-group">
                                    <label>IB Repo Hours</label>
                                    <input
                                        id="ibEstimatedBlockHours"
                                        class="form-control"
                                        #ibEstimatedBlockHours="ngModel"
                                        min="0"
                                        name="ibEstimatedBlockHours"
                                        placeholder="IB Repo Hours"
                                        type="number"
                                        [disabled]="isEditBlockTimeRecord"
                                        [(ngModel)]="blockTimeReportRecord.ibEstimatedBlockHours"
                                        (change)="calculateActualBlockTime()"
                                    />
                                </div>
                            </div>
                            <div class="dialog-cell">
                                <div class="form-group">
                                    <label>Est. Block Hours</label>
                                    <input
                                        id="estimatedBlockHours"
                                        class="form-control"
                                        #estimatedBlockHours="ngModel"
                                        name="estimatedBlockHours"
                                        placeholder="Est. Block Hours"
                                        type="number"
                                        [disabled]="isEditBlockTimeRecord"
                                        [(ngModel)]="blockTimeReportRecord.estimatedBlockHours"
                                    />
                                </div>
                            </div>
                            <div class="dialog-cell">
                                <div class="form-group">
                                    <label>Actual Block Time</label>
                                    <input
                                        id="actualBlockTime"
                                        class="form-control readonly-field"
                                        #actualBlockTime="ngModel"
                                        name="actualBlockTime"
                                        placeholder="Actual Block Time"
                                        readonly
                                        tabindex="-1"
                                        type="number"
                                        [(ngModel)]="blockTimeReportRecord.actualBlockTime"
                                    />
                                    <small
                                        *ngIf="
                                            blockTimeReportRecord.ibRepoAwaitingVerification &&
                                            blockTimeReportRecord.ibRepoVerificationReason === 'NoDeparture'
                                        "
                                        class="text-muted d-block mt-1"
                                    >
                                        Not counted until confirmed
                                    </small>
                                </div>
                            </div>
                            <div class="dialog-cell">
                                <div class="form-group">
                                    <label>Billed Hours</label>
                                    <input
                                        id="totalBilledHours"
                                        class="form-control"
                                        #totalBilledHours="ngModel"
                                        min="0"
                                        name="totalBilledHours"
                                        placeholder="Billed Hours"
                                        type="number"
                                        [(ngModel)]="blockTimeReportRecord.totalBilledHours"
                                    />
                                </div>
                            </div>
                            <div class="dialog-cell">
                                <div class="form-group">
                                    <label>
                                        Billed Hours
                                        <mat-icon
                                            class="billed-hours-info-icon"
                                            fontIcon="info_outline"
                                            aria-label="Billed Hours info"
                                            matTooltip="This should match the vendors invoice exactly"
                                            matTooltipPosition="right"
                                        ></mat-icon>
                                    </label>
                                    <input
                                        id="totalBilledHours"
                                        class="form-control"
                                        #totalBilledHours="ngModel"
                                        min="0"
                                        name="totalBilledHours"
                                        placeholder="Billed Hours"
                                        type="number"
                                        [(ngModel)]="blockTimeReportRecord.totalBilledHours"
                                    />
                                </div>
                            </div>
                            <ng-container *ngIf="isCancellationHoursVisible">
                                <div class="dialog-cell">
                                    <div class="form-group">
                                        <label>Cancellation Hours</label>
                                        <input
                                            id="cancellationHours"
                                            class="form-control"
                                            #cancellationHours="ngModel"
                                            min="0"
                                            name="cancellationHours"
                                            placeholder="Cancellation Hours"
                                            type="number"
                                            [disabled]="isEditBlockTimeRecord"
                                            [(ngModel)]="blockTimeReportRecord.cancellationHours"
                                            (change)="calculateActualBlockTime()"
                                        />
                                    </div>
                                </div>
                            </ng-container>
                            <div class="dialog-cell">
                                <div class="form-group">
                                    <label>Cost</label>
                                    <input
                                        id="cost"
                                        class="form-control"
                                        #cost="ngModel"
                                        name="cost"
                                        placeholder="Cost"
                                        type="number"
                                        [(ngModel)]="blockTimeReportRecord.cost"
                                        (ngModelChange)="calculateRateAndFlightMargin()"
                                    />
                                </div>
                            </div>
                            <div class="dialog-cell">
                                <div class="form-group">
                                    <label>Profit</label>
                                    <input
                                        id="profit"
                                        class="form-control"
                                        #profit="ngModel"
                                        name="profit"
                                        placeholder="Profit"
                                        type="number"
                                        [(ngModel)]="blockTimeReportRecord.profit"
                                        (ngModelChange)="calculateRateAndFlightMargin()"
                                    />
                                </div>
                            </div>
                            <div class="dialog-cell">
                                <div class="form-group position-relative">
                                    <label>Rate</label>
                                    <input
                                        id="rate"
                                        class="form-control pr-5"
                                        #rate="ngModel"
                                        disabled
                                        name="rate"
                                        placeholder="Rate"
                                        type="number"
                                        [(ngModel)]="blockTimeReportRecord.rate"
                                    />
                                    <span class="position-absolute top-right-position">%</span>
                                </div>
                            </div>
                            <div class="dialog-cell">
                                <div class="form-group position-relative">
                                    <label>Flight Margin</label>
                                    <input
                                        id="flightMargin"
                                        class="form-control pr-5"
                                        #flightMargin="ngModel"
                                        disabled
                                        name="flightMargin"
                                        placeholder="Flight Margin"
                                        type="number"
                                        [(ngModel)]="blockTimeReportRecord.flightMargin"
                                    />
                                    <span class="position-absolute top-right-position">%</span>
                                </div>
                            </div>
                            <div class="dialog-cell">
                                <div class="form-group">
                                    <label>Invoice #</label>
                                    <input
                                        id="invoiceID"
                                        class="form-control"
                                        #invoiceID="ngModel"
                                        name="invoiceID"
                                        placeholder="Invoice #"
                                        type="text"
                                        [(ngModel)]="blockTimeReportRecord.invoiceID"
                                    />
                                </div>
                            </div>
                            <div class="dialog-cell">
                                <div class="form-group">
                                    <label>
                                        <span>Month and Year </span><span class="text-danger">*</span>
                                        <span *ngIf="blockTimeReportForm.submitted && monthYear.invalid">
                                            <span *ngIf="monthYear.errors.required" class="text-danger">required</span>
                                        </span>
                                    </label>
                                    <ngx-select-dropdown
                                        id="monthYear"
                                        #monthYear="ngModel"
                                        [class.dropdown-readonly]="!blockTimeReportRecord.srCreatedOnDate"
                                        name="monthYear"
                                        required
                                        tabindex="0"
                                        [config]="monthYearDropdownSetting"
                                        [disabled]="!blockTimeReportRecord.srCreatedOnDate"
                                        [multiple]="false"
                                        [options]="monthYearList"
                                        [(ngModel)]="blockTimeReportRecord.monthYear"
                                    />
                                </div>
                            </div>
                        </div>
                        <div class="row">
                            <div class="col-lg-12 col-md-12 col-sm-12 col-xs-12">
                                <div class="form-group">
                                    <label class="mt-2">Note</label>
                                    <div>
                                        <textarea
                                            id="note"
                                            class="form-control"
                                            #note="ngModel"
                                            name="note"
                                            placeholder="Note"
                                            rows="2"
                                            [(ngModel)]="blockTimeReportRecord.note"
                                        ></textarea>
                                    </div>
                                </div>
                            </div>
                            <div class="col-sm-12 col-xs-12 px-0">
                                <div *ngIf="isEditBlockTimeRecord" class="col-lg-3 col-md-4 col-sm-4 col-xs-4">
                                    <div class="form-group">
                                        <label class="mt-2">Contracted</label>
                                        <div>
                                            <input
                                                id="isContracted"
                                                class="block_time_report_checkbox"
                                                #isContracted="ngModel"
                                                name="isContracted"
                                                placeholder="Contracted"
                                                type="checkbox"
                                                [disabled]="true"
                                                [(ngModel)]="blockTimeReportRecord.isContracted"
                                            />
                                        </div>
                                    </div>
                                </div>
                                <div class="col-lg-3 col-md-4 col-sm-4 col-xs-4">
                                    <div class="form-group">
                                        <label class="mt-2">A/R</label>
                                        <div>
                                            <input
                                                id="ar"
                                                class="block_time_report_checkbox"
                                                #ar="ngModel"
                                                name="ar"
                                                placeholder="A/R"
                                                type="checkbox"
                                                [(ngModel)]="blockTimeReportRecord.ar"
                                            />
                                        </div>
                                    </div>
                                </div>
                                <div class="col-lg-3 col-md-4 col-sm-4 col-xs-4">
                                    <div class="form-group">
                                        <label class="mt-2">A/P</label>
                                        <div>
                                            <input
                                                id="ap"
                                                class="block_time_report_checkbox"
                                                #ap="ngModel"
                                                name="ap"
                                                placeholder="A/P"
                                                type="checkbox"
                                                [(ngModel)]="blockTimeReportRecord.ap"
                                            />
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
                <div class="modal-footer">
                    <button
                        class="flat-butt flat-danger-butt flat-danger-grad-butt margin-right-10"
                        #cancelBtnRef
                        data-dismiss="modal"
                        (click)="closeBlockTimeReportModel()"
                    >
                        Cancel
                    </button>
                    <button
                        class="flat-butt flat-info-butt flat-info-grad-butt save-btn"
                        (click)="addEditBlockTimeRecord(blockTimeReportForm)"
                    >
                        {{ isEditBlockTimeRecord ? 'Update' : 'Add' }}
                    </button>
                </div>
            </form>
        </div>
    </div>
</div>
